export const CSS = {
  header: "header",
  month: "month",
  chevron: "chevron",
  suffix: "suffix",
  yearSuffix: "year--suffix",
  yearWrap: "year-wrap",
  textReverse: "text--reverse",
};

export const ICON = {
  chevronLeft: "chevron-left",
  chevronRight: "chevron-right",
};
